export const contentMaxWidth = 1000;
export const illustrationMaxHeight = "70vh";
export const indentationStep = 40;

export const safeAreaInsetLeft = `env(safe-area-inset-left)`;
export const safeAreaInsetRight = `env(safe-area-inset-right)`;
export const safeAreaInsetTop = `env(safe-area-inset-top)`;
export const safeAreaInsetBottom = `env(safe-area-inset-bottom)`;
